
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10